import React from 'react'
import { Tooltip } from '@chakra-ui/react'
import { Text, HStack } from '@chakra-ui/react'
import { Tag, TagLeftIcon, TagLabel } from '@chakra-ui/react'
import { FaCheckCircle, FaMinusCircle, FaTimesCircle } from 'react-icons/fa'

import SharedStack from '~components/shared/wrappers/shared-stack'
import { Icon } from '@chakra-ui/react'

enum MatchIntensity {
    None = 'none',
    Half = 'half',
    Full = 'full',
}

interface MatchingTagProps {
    doesMatch?: boolean[]
    attribute: string
    matchingFields?: string[]
}

export default function MatchingTag({
    doesMatch,
    attribute,
    matchingFields,
}: MatchingTagProps) {
    const match = doesMatch?.every(Boolean)
        ? MatchIntensity.Full
        : doesMatch?.some(Boolean)
        ? MatchIntensity.Half
        : MatchIntensity.None

    return (
        <Tooltip
            isDisabled={!matchingFields || matchingFields.length < 1}
            label={
                <SharedStack>
                    {matchingFields?.map((field, i) => (
                        <HStack spacing={2}>
                            <Text>{field}</Text>
                            <Icon
                                as={getMatchIcon(
                                    doesMatch?.at(i)
                                        ? MatchIntensity.Full
                                        : MatchIntensity.None
                                )}
                                color={`${getMatchColor(
                                    doesMatch?.at(i)
                                        ? MatchIntensity.Full
                                        : MatchIntensity.None
                                )}.500`}
                            />
                        </HStack>
                    ))}
                </SharedStack>
            }
        >
            <Tag
                colorScheme={getMatchColor(match)}
                size="sm"
                cursor={!!matchingFields ? 'help' : 'default'}
            >
                <TagLeftIcon as={getMatchIcon(match)} />
                <TagLabel>Matching {attribute}</TagLabel>
            </Tag>
        </Tooltip>
    )
}

function getMatchColor(match: MatchIntensity) {
    switch (match) {
        case MatchIntensity.None:
            return 'red'
        case MatchIntensity.Half:
            return 'yellow'
        case MatchIntensity.Full:
            return 'brand'
    }
}

function getMatchIcon(match: MatchIntensity) {
    switch (match) {
        case MatchIntensity.None:
            return FaTimesCircle
        case MatchIntensity.Half:
            return FaMinusCircle
        case MatchIntensity.Full:
            return FaCheckCircle
    }
}
